var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoor = function SvgDoor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4281_5478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5293 55.6465H20.3528V75.4994H11.5293V55.6465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9999 0.5C23.404 0.5 11.5293 12.3747 11.5293 26.9706V38H20.3528V26.9706C20.3528 17.24 28.2693 9.32353 37.9999 9.32353C47.7305 9.32353 55.6469 17.24 55.6469 26.9706V38H64.4705V26.9706C64.4705 12.3747 52.5958 0.5 37.9999 0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5293 42.4121H20.3528V51.2357H11.5293V42.4121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6465 55.6465H64.47V75.4994H55.6465V55.6465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6465 42.4121H64.47V51.2357H55.6465V42.4121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7646 75.4998H51.2353V35.7939H24.7646V75.4998ZM42.4117 46.8234H46.8235V55.6469H42.4117V46.8234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 13.7354C30.702 13.7354 24.7646 19.6727 24.7646 26.9706V31.3824H51.2353V26.9706C51.2353 19.6727 45.2979 13.7354 38 13.7354Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4281_5478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/door.bca89ffbd39b818fe6cdc2395fd28360.svg";